import angular from 'angular';
import contactAddressTable from './contactAddressTable';

export default angular
  .module('components.contactAddressTable', [])
  .component('contactAddressTable', contactAddressTable).name;
